/***
 ** Here you can override styles
 */
import { createGlobalStyle } from 'styled-components'
import theme from './theme.json'
import './fonts.scss'

// eslint-disable-next-line
const BrandStyle = createGlobalStyle`
  .ui.primary.button {
    background-color: ${theme.primaryColor};
  }
`

export default BrandStyle
